import { DeleteEvent, GetEvent, PatchEvent, SubmitEvent } from '~/machines/base-crud';
import { CMETraining } from '~/types';
import { deleteData, getData, patchData, postData } from '../../../utils/service';
import { SubmitCMETrainingEvent } from './events';
import { CMETrainingFormValues, Context } from './types';
import { CMETrainingApiToForm, CMETrainingFormToApi, CMETrainingsApiToForm } from './utils';

const CME_TRAINING_ROUTE_NAME = 'cmeTraining';
export const CME_TRAINING_ROUTES = {
  get: '/cme-training/{providerId}',
  post: '/cme-training',
  patch: '/cme-training/{id}',
  delete: '/cme-training/{id}',
};

interface CMEInput<T> {
  input: {
    context: Context;
    event: T;
  };
}

export const API_CALLS = {
  get: async ({ input }: CMEInput<GetEvent>): Promise<CMETraining[]> => {
    const { sort } = input.context;
    return await getData(CME_TRAINING_ROUTE_NAME, {
      pathParams: {
        providerId: input.context.providerId.toString(),
      },
      sort,
      transformResponse: CMETrainingsApiToForm,
    });
  },
  create: async ({ input }: CMEInput<SubmitEvent<CMETrainingFormValues>>): Promise<CMETraining> => {
    const event = input.event as SubmitCMETrainingEvent;
    return await postData(CME_TRAINING_ROUTE_NAME, {
      data: event.values,
      transformRequest: CMETrainingFormToApi,
      transformResponse: CMETrainingApiToForm,
    });
  },
  delete: async ({ input }: CMEInput<DeleteEvent>) => {
    return await deleteData(CME_TRAINING_ROUTE_NAME, {
      pathParams: { id: input.event.payload.id.toString() },
    });
  },
  patch: async ({ input }: CMEInput<PatchEvent<CMETrainingFormValues>>): Promise<CMETraining> => {
    return await patchData(CME_TRAINING_ROUTE_NAME, {
      pathParams: { id: input.event.values.id?.toString() || '' },
      data: input.event.values,
      transformRequest: CMETrainingFormToApi,
      transformResponse: CMETrainingApiToForm,
    });
  },
};
